import PageLayout from "@/components/base/page-layout";
// import Stats from "@/components/statistics";
import withErrorBoundary from "@/components/hoc/with-error-boundary";
import React from "react";
import useQueryInventory from "@/hooks/queries/useQueryInventory";
import Inventory from "@/components/inventory";
import Backdrop from "@/components/base/backdrop";

const InventoryPage: React.FC = () => {
  const { data: inventory, isFetching } = useQueryInventory();

  if (!inventory) {
    return <Backdrop loading={isFetching} />;
  }

  return (
    <PageLayout title="Inventory">
      <Inventory data={inventory} />
    </PageLayout>
  );
};

export default withErrorBoundary({ component: "InventoryPage" })(InventoryPage);
